import { useWaitlistCount } from '@/hooks/useWaitlistCount';

const MAX_FOUNDING = 10_000;

const ScarcityBar = () => {
  const { count } = useWaitlistCount();
  const remaining = Math.max(0, MAX_FOUNDING - count);
  const fillPct = Math.min(100, (count / MAX_FOUNDING) * 100);
  const isFull = remaining <= 0;

  const isOrange = fillPct >= 80;
  const shouldPulse = fillPct >= 90 && !isFull;

  const barColor = isOrange ? 'hsl(var(--hype))' : 'hsl(var(--primary))';

  return (
    <div className="w-full max-w-xl mx-auto mt-6">
      {/* Counter */}
      <p className="text-center text-muted-foreground text-sm font-mono mb-2">
        {isFull ? (
          <>
            All <span className="text-foreground font-bebas text-lg">10,000</span> founding spots claimed.
            <br />
            <span className="text-xs">You can still join the general waitlist.</span>
          </>
        ) : (
          <>
            <span className="text-foreground font-bebas text-lg">{count.toLocaleString()}</span>{' '}
            of 10,000 founding spots claimed
          </>
        )}
      </p>

      {/* Progress bar */}
      <div className="relative h-2 w-full overflow-hidden rounded-full bg-secondary">
        <div
          className={`h-full rounded-full transition-all duration-700 ease-out ${shouldPulse ? 'animate-pulse' : ''}`}
          style={{
            width: `${fillPct}%`,
            backgroundColor: barColor,
            boxShadow: `0 0 8px ${barColor}`,
          }}
        />
      </div>

      {/* Urgency banner under 1,000 remaining */}
      {remaining > 0 && remaining < 1000 && (
        <div
          className="mt-4 p-3 rounded-lg border text-center font-mono text-sm leading-relaxed"
          style={{
            borderColor: 'hsl(var(--hype) / 0.4)',
            backgroundColor: 'hsl(var(--hype) / 0.08)',
            color: 'hsl(var(--hype))',
          }}
        >
          <p className="font-bebas text-lg tracking-wide">Founding spots are almost gone.</p>
          <p className="text-muted-foreground text-xs mt-1">
            After 10,000 — general waitlist only.
          </p>
        </div>
      )}
    </div>
  );
};

export default ScarcityBar;
